import React, { useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import PreviousPeriods from '../../components/Report/PreviousPeriods';
import NewPeriod from '../../components/Report/NewPeriod';
import TrialBalance from '../../components/Report/TrialBalance';
import { useReport } from '../../DataStore/ReportContext';
import AlertSwitchPeriod from '../../components/Period/AlertSwitchPeriod';
import { useTheme } from '../../DataStore/ThemeContext';
import AlertClosePeriod from '../../components/Period/AlertClosePeriod';
import Notification from '../../components/Common/Notification';

const FinancialPeriodPage = () => {

    const { getFinancialPeriods, selectedYear } = useReport();
    const [showSwitchAlert, setShowSwitchAlert] = useState(false);
    const [showClosePeriod, setShowClosePeriod] = useState(false);
    const {setNotify} = useTheme();

    const handleSwitchPeriod = () => {
        // Logic to switch to a different financial period
        if(!selectedYear) {
            setNotify(<Notification type="warning" message="No financial period selected. Please select a period to switch." iconClass="fa fa-info-circle"/>);
            return;
        }
        setShowSwitchAlert(true);
    };

    return (<>
        <PageContainer>
            <MainContent>
                {/* Page Title */}
                <PageTitle
                    title="Financial Period"
                    description="All transactions are recorded within a given Financial Period. The system must have a valid trial balance before creating a new period."
                    iconClass="fa-regular fa-calendar-days"
                    sticky={true}
                    PageActions={() => (
                        <>
                            <ActionDropdownItem iconClass="fa fa-exchange text-success" label="Switch to Period" onClick={handleSwitchPeriod}/>
                            <ActionDropdownItem iconClass="fa fa-lock text-danger" label="Close Current Period" onClick={()=>setShowClosePeriod(true)}/>
                            <ActionDropdownItem iconClass="fa fa-sync" label="Refresh" onClick={getFinancialPeriods} />
                        </>
                    )}
                />
                <Notification message="Before creating a new financial period, make sure you have a balanced trial balance." iconClass="fa fa-question-circle"/>
                <div className="row">
                   
                    <div className="col-md-7">
                        {/* Section: Create New Financial Year */}
                        <NewPeriod />

                        {/* Section: Current Trial Balance */}
                        <TrialBalance />
                    </div>

                    <div className="col-md-5">
                        <PreviousPeriods />
                    </div>

                </div>
            </MainContent>
        </PageContainer>
        {selectedYear && <AlertSwitchPeriod show={showSwitchAlert} handleClose={()=>setShowSwitchAlert(false)} selection={selectedYear} />}
        <AlertClosePeriod show={showClosePeriod} handleClose={()=>setShowClosePeriod(false)} />
        </>
    );
};

export default FinancialPeriodPage;
